import Main from "../../views/main";
import { ParentView } from "@/ladmin";

export default [
  {
    path: "/pay",
    name: "pay",
    component: Main,
    meta: {
      disabled: true,
      label: "停车缴费"
    },
    children: [
      {
        name: "billList",
        path: "billList",
        component: () => import("@/views/Payment/Bill/billList"),
        meta: {
          label: "账单管理"
        }
      },
      {
        name: "billListParent",
        path: "billList",
        component: ParentView,
        redirect: { name: "billList" },
        meta: {
          label: "账单管理"
        },
        children: [
          {
            name: "billDetailBox",
            path: "billDetailBox",
            component: () => import("@/views/Payment/Bill/billDetailBox"),
            meta: {
              label: "账单详情"
            }
          }
        ]
      },
      {
        name: "userWalletList",
        path: "userWalletList",
        component: () => import("@/views/Payment/User/list"),
        meta: {
          label: "用户钱包"
        }
      },
      {
        name: "userWalletListParent",
        path: "userWalletList",
        component: ParentView,
        redirect: { name: "userWalletList" },
        meta: {
          label: "用户钱包"
        },
        children: [
          {
            name: "userWalletDetailBox",
            path: "userWalletDetailBox",
            component: () => import("@/views/Payment/User/userWalletDetailBox"),
            meta: {
              label: "用户钱包详情"
            }
          }
        ]
      },
      // {
      //   name: "userDetails",
      //   path: "userDetails",
      //   component: () => import("@/views/Payment/User/userDetails"),
      //   meta: {
      //     label: "用户钱包"
      //   }
      // },
      // {
      //   name: "userDetailsParent",
      //   path: "userDetails",
      //   component: ParentView,
      //   redirect: { name: "userDetails" },
      //   meta: {
      //     label: "用户钱包"
      //   },
      //   children: [
      //     {
      //       name: "billDetailBox",
      //       path: "billDetailBox",
      //       component: () => import("@/views/Payment/User/billDetailBox"),
      //       meta: {
      //         label: "账单详情"
      //       }
      //     }
      //   ]
      // },
      {
        name: "paySimulateTest",
        path: "paySimulateTest",
        component: () => import("@/views/Payment/paySimulateTest"),
        meta: {
          label: "模拟测试"
        }
      }
    ]
  }
];
